import { render } from "./PurchaseOrdersReport.vue?vue&type=template&id=133059dd&ts=true"
import script from "./PurchaseOrdersReport.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrdersReport.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__